// 物流方式
export const logisticsModeList = [
  { label: '快递配送', value: '快递配送' },
  { label: '物流配送', value: '物流配送' },
  { label: '客户自提', value: '客户自提' },
  { label: '仓库配送', value: '仓库配送' }
]
// 提货人
export const consigneeLinkList = [
  { label: '客户', value: '客户' },
  { label: '销售代提', value: '销售代提' }
]
// 物流费用
export const logisticsFeesList = [
  { label: '合同结算', value: '合同结算' },
  { label: '客户承担', value: '客户承担' }
]
// 调入合同搜索条件
export const searchList = [
  { label: '合同编号', value: 'contractCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '产品名称', value: 'proName' },
  { label: '产品型号', value: 'proType' },
  { label: '订货号', value: 'orderNumber' }
]
// 询价单列表tabs状态
export const inquiryListTabs = [
  { title: '全部', name: '全部' },
  { title: '询价已反馈', name: '询价已反馈' },
  { title: '询价待反馈', name: '询价待反馈' },
  { title: '报价已生成', name: '报价已生成' }
]
// 询价单筛选条件
export const inquiryScreenCondition = [
  { label: '询价单编号', value: 'orderCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '产品名称', value: 'proName' },
  { label: '型号', value: 'proType' },
  { label: '订货号', value: 'orderNumber' },
  { label: '询价时间', value: 'miDate' },
  { label: '供货价反馈时间', value: 'maxDate' },
  { label: '报价状态', value: 'isQuotation' },
  { label: '生成合同', value: 'isContract' },
  { label: '制单时间', value: 'createDate' }
]
// 合同列表tabs状态
export const contractListTabs = [
  { title: '全部', name: '1' },
  { title: '待签署', name: '10' },
  { title: '履行中', name: '4' },
  { title: '已履行', name: '5' },
  { title: '已作废', name: '6' }
]
// 合同列表筛选条件
export const contractScreenCondition = [
  { label: '合同编号', value: 'contractCode' },
  { label: '客户合同编号', value: 'customerContractCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '付款类型', value: 'payType' },
  { label: '合同金额', value: 'contractTotal' },
  { label: '合同状态', value: 'signState' },
  { label: '发货状态', value: 'deliverState' },
  { label: '开票状态', value: 'invoiceState' },
  { label: '签订时间', value: 'signDate' },
  { label: '型号', value: 'proType' },
  { label: '订货号', value: 'orderNumber' }
]
// 合同回款划拨筛选条件
export const contractReturnMoneyTransfer = [
  { label: '客户编号', value: 'cusCode' },
  { label: '客户名称', value: 'cusName' },
  { label: '贸易额', value: 'contractTotal' },
  { label: '应收账款', value: 'accountsReceivable' },
  { label: '已到期账款', value: 'accountsDue' },
  { label: '已收账款', value: 'paymentReceived' },
  { label: '待划拨合同数', value: 'number' }
]
// 收货人
export const consigneeList = [
  { label: '张三', value: '张三' },
  { label: '李四', value: '李四' },
  { label: '王五', value: '王五' }
]
// 付款类型
export const paymentTypeList = [
  { label: '约定账期', value: 1 },
  { label: '全款发货', value: 2 },
  { label: '先货后款', value: 3 },
  { label: '期货期款', value: 4 }
]
// 约定条件
export const agreedConditionsList = [
  { label: '发货后', value: 1 },
  { label: '发货加开票后', value: 2 },
  { label: '开票后', value: 3 }
]
// 合同详情tabs
export const contractEditTabs = [
  { title: '账务信息', name: '账务信息' },
  { title: '产品清单', name: '产品清单' },
  { title: '退货产品', name: '退货产品' },
  { title: '备货管理', name: '备货管理' },
  { title: '发货管理', name: '发货管理' },
  { title: '票据管理', name: '票据管理' },
  { title: '任务列表', name: '任务列表' },
  { title: '售后管理', name: '售后管理' },
  { title: '相关附件', name: '相关附件' }
]
// 质保期限
export const deadlineList = [
  { label: '1个月', value: '1个月' },
  { label: '2个月', value: '2个月' },
  { label: '3个月', value: '3个月' },
  { label: '6个月', value: '6个月' },
  { label: '12个月', value: '12个月' },
  { label: '18个月', value: '18个月' },
  { label: '24个月', value: '24个月' }
]
// 合同详情产品清单tabs
export const productListTabs = [
  { title: '产品清单', name: '产品清单' },
  { title: '报缺清单', name: '报缺清单' }
]
// 合同列表筛选条件
export const shippedProductList = [
  { label: '品牌', value: '品牌' },
  { label: '系列', value: '系列' },
  { label: '产品名称', value: '产品名称' },
  { label: '型号', value: '型号' },
  { label: '订货号', value: '订货号' },
  { label: '类型', value: '类型' },
  { label: '货期', value: '货期' }
]
// 合同回款划拨
export const returnMoneyTransferTabs = [
  { title: '待划拨客户', name: '1' },
  { title: '欠款客户', name: '0' }
]
// 合同回拨划款tabs
export const transferEditTabs = [
  { title: '待划拨合同', name: '待划拨合同' },
  { title: '待划拨工单', name: '待划拨工单' }
]
// 销售备货 产品清单tabs
export const stockRecordTabs = [
  { title: '未备货', name: '1' },
  { title: '备货审核', name: '2' },
  { title: '备货中', name: '3' },
  { title: '已备货', name: '4' }
]
// 销售发货 产品清单tabs
export const shipmentsRecordTabs = [
  { title: '未发货', name: '1' },
  { title: '发货审核', name: '2' },
  { title: '发货中', name: '3' },
  { title: '已发货', name: '4' }
]
// 销售开票 产品清单tabs
export const contractInvoicingManagementTabs = [
  { title: '未开票', name: '1' },
  { title: '开票审核', name: '2' },
  { title: '已开票', name: '3' }
]
// 销售备发货开票 记录tabs
export const sellRecordcountTabs = [
  { title: '备货记录', name: '1' },
  { title: '发货记录', name: '2' },
  { title: '开票记录', name: '3' }
]
// 承兑汇票收款筛选条件
export const acceptDraftCollectionsCondition = [
  { label: '收款编号', value: 'receiptNumber' },
  { label: '客户名称', value: 'cusName' },
  { label: '承兑票号', value: 'billNumber' },
  { label: '票据金额', value: 'billMoney' },
  { label: '出票单位', value: 'billCompany' },
  { label: '出票银行', value: 'billBank' },
  { label: '出票日期', value: 'billDate' },
  { label: '到期日期', value: 'billEnddate' },
  { label: '状态', value: 'state' },
  { label: '发起人', value: 'createUser' },
  { label: '发起时间', value: 'createDate' },
  { label: '处理人', value: 'processUser' },
  { label: '处理时间', value: 'processDate' }
]

// 坏账 记录tabs
export const badDebtRecordTbas = [
  { title: '全部', name: '0' },
  { title: '审核中', name: '1' },
  { title: '财务确认中', name: '4' },
  { title: '审核不通过', name: '3' }
]
export const afterSaleRecordCondition = [
  { label: '退货编号', value: 'returnNumber' },
  // { label: '合同编号', value: '111' },
  // { label: '客户合同编号', value: '111' },
  { label: '客户名称', value: 'cusName' },
  { label: '退货产品价值', value: 'salePriceTotal' },
  { label: '罚没费用', value: 'forfeitureProiceTotal' },
  // { label: '方案执行', value: '111' },
  { label: '退货状态', value: 'state' },
  { label: '申请时间', value: 'createTime' }
]
// 销售佣金统计tabs
export const sellCommisStatiTbas = [
  { title: '当月结算合同', name: '当月结算合同' },
  // { title: '售后', name: '售后' },
  { title: '物流费用', name: '物流费用' },
  { title: '资金占用', name: '资金占用' },
  { title: '往期流水更正', name: '往期流水更正' },
  { title: '绩效', name: '绩效' }
]
// 客户提现记录筛选条件
export const financePayCondition = [
  { label: '提现编号', value: 'payNumber' },
  { label: '客户名称', value: 'cusName' },
  { label: '提现金额', value: 'amount' },
  { label: '提现状态', value: 'state' },
  { label: '发起人', value: 'createUser' },
  { label: '发起时间', value: 'createDate' },
  { label: '转账处理人', value: 'processSecUser' },
  { label: '处理时间', value: 'processSecDate' }
]

// 坏账记录筛选条件
export const badDebtScreenCondition = [
  { label: '坏账编号', value: 'badNumber' },
  { label: '合同编号', value: 'orderContractNumber' },
  { label: '客户名称', value: 'cusName' },
  { label: '合同金额', value: 'contractTotal' },
  { label: '应收账款', value: 'accountsCollect' },
  { label: '已收账款', value: 'accountsReceived' },
  { label: '坏账金额', value: 'badCount' }
]
